/**
 * 車輌検索ダイアログモジュール（GET /car/search 想定の UI・モック）
 */

// メインコンポーネント
export { default as SyaryoDialog } from "./SyaryoDialog.js";

// カスタムフック
export { useSyaryoDialog } from "./useSyaryoDialog.js";

// デフォルトエクスポート（メインコンポーネント）
export { default } from "./SyaryoDialog.js";

export {
  buildCarFormFields,
  dialogCriteriaToSeriesAndOptions,
  mapPcarApiPayloadToRows,
  mapPcarDataItemToCarSearchRow,
  parseEbeCMakerCd,
  parseSfrmFromFrameno,
  resolvePcarUrl,
  searchCarAtUrl,
  PCAR_LIST_COLUMNS,
} from "./pCarApi.js";

export { DEFAULT_SYARYO_PCAR_SEARCH_URL, resolveSyaryoPcarSearchUrl } from "./syaryoPcarConfig.js";

export { patchFromPcarApiCarRow } from "./carSearchFormBridge.js";
